module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"levelloaderror","format":"jsonschema","version":"2-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"unloaded":{"type":"string","maxLength":65535}},"required":["user","unloaded"],"additionalProperties":true}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/levelloaderror.json
// module id = 551
// module chunks = 97